// extracted by mini-css-extract-plugin
export default {"cls1":"PremiumBadge-cls1_KZC","cls2":"PremiumBadge-cls2_y6B PremiumBadge-cls1_KZC"};